module.exports = __webpack_public_path__ + "static/covid-omics-kitchen-5e71ced8117c62f1622958286a0e83ba.png";